export const isString = (value: unknown): value is string => typeof value === 'string';

export const isUndefined = (value: unknown): value is undefined => typeof value === 'undefined';

export const booleanGuard = <T>(value: T | undefined | null | 0 | 0n | '' | false): value is T => Boolean(value);
